module.exports = __webpack_public_path__ + "img/eu.b4903985.svg";